import { getVersion } from './chartVersionServiceModule';

angular.module('signalview.chart').service('chartVersionService', [
    function () {
        return {
            getVersion: getVersion,
        };
    },
]);
